module.exports = __webpack_public_path__ + "static/wave-ae559195111d3eca130445e8f4b22d41.gif";